import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function DesignLoadErrorNotification(props) {
  return (
    <Notification dismiss={props.dismiss} title="Oops!">
      <p className="ndx-cta1">We were unable to load your design.</p>
      <Button
        size="large"
        variant="secondary"
        className="notification-cta"
        href="#/help"
        onClick={props.dismiss}>
        Contact Us for Help
      </Button>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

DesignLoadErrorNotification.propTypes = propTypes;

DesignLoadErrorNotification.displayName = 'DesignLoadErrorNotification';
